import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ScoringState {
  // Per-project flag: true when the saved scoring rules diverge from the
  // last global rescore. Cleared when rescore-all completes.
  dirtyByProject: Record<string, boolean>;
  setDirty: (slug: string, dirty: boolean) => void;
  isDirty: (slug: string) => boolean;
}

export const useScoringStore = create<ScoringState>()(
  persist(
    (set, get) => ({
      dirtyByProject: {},
      setDirty: (slug, dirty) =>
        set((s) => {
          if (!slug) return {};
          if (Boolean(s.dirtyByProject[slug]) === dirty) return {};
          const next = { ...s.dirtyByProject };
          if (dirty) next[slug] = true;
          else delete next[slug];
          return { dirtyByProject: next };
        }),
      isDirty: (slug) => Boolean(get().dirtyByProject[slug]),
    }),
    { name: "prism.scoring" },
  ),
);
